import { getProspectsUnreadSummary } from '@/api/prospects.api.js'
import { createInboxSocket } from '@/utils/inboxSocket.js'

let totalUnread = 0
const listeners = new Set()
const eventListeners = new Set()
let inboxSocket = null
let refetchTimer = null
let started = false

function notify() {
  for (const listener of listeners) {
    try {
      listener(totalUnread)
    } catch (_err) {
      // ignore subscriber errors
    }
  }
}

function scheduleRefetchSummary() {
  if (refetchTimer) {
    clearTimeout(refetchTimer)
  }
  refetchTimer = setTimeout(() => {
    refetchTimer = null
    fetchInboxUnreadSummary()
  }, 300)
}

export function getTotalUnread() {
  return totalUnread
}

export function formatUnreadBadge(count) {
  const value = Math.max(0, Number(count) || 0)
  if (value <= 0) {
    return null
  }
  return value > 99 ? '99+' : String(value)
}

export function subscribeInboxUnread(listener) {
  if (typeof listener === 'function') {
    listeners.add(listener)
    listener(totalUnread)
  }
  return () => {
    listeners.delete(listener)
  }
}

export function subscribeInboxEvents(handler) {
  if (typeof handler !== 'function') {
    return () => {}
  }
  eventListeners.add(handler)
  return () => {
    eventListeners.delete(handler)
  }
}

function dispatchInboxEvent(payload) {
  for (const handler of eventListeners) {
    try {
      handler(payload)
    } catch (_err) {
      // ignore subscriber errors
    }
  }
}

function handleSocketPayload(payload) {
  dispatchInboxEvent(payload)

  if (!payload || typeof payload !== 'object') {
    return
  }
  if (payload.type === 'unread' || payload.type === 'message') {
    scheduleRefetchSummary()
  }
}

export async function fetchInboxUnreadSummary() {
  try {
    const response = await getProspectsUnreadSummary()
    const data = response.data || {}
    totalUnread = Math.max(0, Number(data.totalUnread) || 0)
    notify()
    return totalUnread
  } catch (_err) {
    return totalUnread
  }
}

export function startInboxUnreadHub() {
  if (started) {
    return
  }
  started = true

  fetchInboxUnreadSummary()

  if (!inboxSocket) {
    inboxSocket = createInboxSocket({
      onMessage: (payload) => handleSocketPayload(payload)
    })
  }
}

export function stopInboxUnreadHub() {
  started = false
  if (refetchTimer) {
    clearTimeout(refetchTimer)
    refetchTimer = null
  }
  if (inboxSocket) {
    inboxSocket.close()
    inboxSocket = null
  }
}
